import moment from 'moment';

export const formatScope = (scope: string): string => {
  switch (scope?.toUpperCase()) {
    case 'ORG':
      return 'Organization';
    case 'CONTRIBUTOR':
      return 'Contributor';
    case 'TEAM':
      return 'Team';
    default:
      return scope || '';
  }
};

export const formatDate = (date: string) => {
  if (!date) return '-';

  return moment(date, 'YYYY-MM-DD').isValid()
    ? moment(date, 'YYYY-MM-DD').format("DD MMM 'YY")
    : 'Invalid date';
};
